var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtcusdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ltc",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#335E9F;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 249.8,
    cy: 250.2,
    r: 248.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.4,402.6l37-120.2l-40.3,12.3l10.7-29.6l37-11.5l51.7-170.1c1.1-3.6,4.5-6.1,8.3-6.1h52.8 c5.8,0,9.9,5.6,8.3,11.1l-42,140.4l37.9-10.7l-6.9,28.6l-39.1,11.8l-27.3,87.2h139c4.2,0,7.2,4,6.1,8l-12.1,44.2 c-0.8,2.7-3.2,4.6-6.1,4.6H139.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtcusdt);
export default __webpack_public_path__ + "static/media/ltcusdt.0c43f9f128c911723bd9327a5908fcb5.svg";
export { ForwardRef as ReactComponent };